




































import { useFilters } from '@/app/composable';
import { EyeIcon } from '@vue-hero-icons/solid';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import { ContractTransactionStatus } from '../../constants';
import { ContractTransaction } from '../../types';

export default defineComponent({
    name: 'TransactionItem',
    components: {
        EyeIcon,
    },
    props: {
        transaction: {
            type: Object as PropType<ContractTransaction>,
            required: true,
        },
        assetName: {
            type: String,
            required: true,
        },
        contractId: {
            type: String,
            required: true,
        },
    },
    setup(props, { root }) {
        const { formatDateAs } = useFilters();

        const transactionTimestamp = computed(() => {
            return `${formatDateAs(props.transaction.createdAt, true, 'DD/MM/YYYY')} ${formatDateAs(
                props.transaction.createdAt,
                true,
                'HH:mm',
                'UTC',
            )}`;
        });

        const goToContract = () => {
            root.$router.push({
                name: 'contract-details',
                params: {
                    type: props.transaction.bundleId ? 'bundle' : 'details',
                    id: `${props.contractId}`,
                },
            });
        };

        return {
            ContractTransactionStatus,
            transactionTimestamp,
            goToContract,
        };
    },
});
